module.exports = __webpack_public_path__ + "img/healing_boss.7b188fe7.png";